import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const SchoolLevelWrapper = styled.div`
  // padding-bottom: 7em;
`
